import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { API_ENDPOINTS } from '@typings/api-endpoints.type';
import { map, Observable, of } from 'rxjs';
import {
  CreateCompanyManager,
  GetAllUsersResponse,
  GetUserDetailsResponse,
  SignupResponse,
  updateUser,
} from '../../domain';
import { UsersServices } from '../../domain/services/users.service';

@Injectable()
export class UsersServicesImpl implements UsersServices {
  constructor(private client: HttpClient) {}

  getAllUsers(companyId: string): Observable<GetAllUsersResponse> {
    const params = new HttpParams()
      .set('_companyId', companyId)
      .set('populate', 'company');

    return this.client
      .get<GetAllUsersResponse>(
        environment.apiDomain + API_ENDPOINTS.MEMBER.GET_ALL(),
        {
          params,
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  sendLink(): Observable<any> {
    return of({
      data: [
        {
          message: 'Successfully',
        },
      ],
    });
  }
  uploadFile(file: any): Observable<any> {
    return of({
      data: file,
    });
  }
  usersCount(companyId: string): Observable<GetUserDetailsResponse> {
    const params = new HttpParams().set('_companyId', companyId);

    return this.client
      .get<GetUserDetailsResponse>(
        environment.apiDomain + API_ENDPOINTS.MEMBER.COUNT(),
        {
          params,
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  userDetails(userId: string): Observable<any> {
    // const params = new HttpParams().set('_id', userId);
    return this.client
      .get<GetUserDetailsResponse>(
        environment.apiDomain + API_ENDPOINTS.USERS.PROFILE_DATA(userId)
        // {
        //   params,
        // }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  deleteUser(userId: string): Observable<any> {
    const params = new HttpParams().set('_id', userId);
    return this.client
      .delete<GetUserDetailsResponse>(
        environment.apiDomain + API_ENDPOINTS.MEMBER.DELETE(),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  updateUser(userId: string, userData: updateUser): Observable<any> {
    // const params = new HttpParams().set('_id', userId);
    return this.client
      .patch<GetUserDetailsResponse>(
        environment.apiDomain + API_ENDPOINTS.MEMBER.UPDATE(userId),
        userData
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  forgotPassword(emailOrUsername: string): Observable<any> {
    //   {
    //     "data": "4C03B5"
    // }
    // return of({
    //   data: '000000',
    // });
    return this.client
      .post<any>(environment.apiDomain + API_ENDPOINTS.FORGOT_PASSWORD(), {
        emailOrUsername: emailOrUsername,
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  resetPassword(resetPasswordData: any): Observable<any> {
    return this.client
      .post<any>(
        environment.apiDomain + API_ENDPOINTS.RESET_PASSWORD(),
        resetPasswordData
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  updateCompanyManager(userId: string, userData: any): Observable<any> {
    return this.client
      .patch<any>(
        environment.apiDomain + API_ENDPOINTS.MEMBER.UPDATE(userId),
        userData
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  refreshToken(userId: string): Observable<any> {
    return this.client
      .post<any>(environment.apiDomain + API_ENDPOINTS.REFRESH_TOKEN(), {
        refreshToken: userId,
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  confirmAccount(confirmAccountToken: string): Observable<any> {
    return this.client
      .post<any>(environment.apiDomain + API_ENDPOINTS.CONFIRM_PASSWORD(), {
        confirmAccountToken: confirmAccountToken,
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  createCompanyManager(data: CreateCompanyManager): Observable<SignupResponse> {
    return this.client
      .post<any>(
        environment.apiDomain + API_ENDPOINTS.USERS.CREATE_COMPANY_MANAGER(),
        data
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  resendEmail(): Observable<any> {
    return this.client
      .patch<any>(
        environment.apiDomain + API_ENDPOINTS.USERS.RESEND_EMAIL(),
        {}
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  sendCode(data: any): Observable<any> {
    return this.client.post<any>(
      environment.apiDomain + API_ENDPOINTS.SEND_CODE(),
      data
    );
  }

  confirmAccountV1(token: string): Observable<any> {
    return this.client.post<any>(
      environment.apiDomain + API_ENDPOINTS.CONFIRM_ACCOUNT_V1(),
      { confirmAccountToken: token }
    );
  }

  verifyCode(data: any): Observable<any> {
    return this.client.post<any>(
      environment.apiDomain + API_ENDPOINTS.VERIFY_CODE(),
      data
    );
  }

  signUpV3(data: any): Observable<any> {
    return this.client.post<any>(
      environment.apiDomain + API_ENDPOINTS.SIGN_UP_V3(),
      data
    );
  }
  verifyAuthToken(data: any): Observable<any> {
    return this.client.post<any>(
      environment.apiDomain + API_ENDPOINTS.VERIFY_AUTH_TOKEN(),
      data
    );
  }
  checkEmailExist(email: string): Observable<any> {
    return this.client.post<any>(
      environment.apiDomain + API_ENDPOINTS.CHECK_EMAIL_EXIST(),
      { email }
    );
  }
}
